import { createFileRoute } from "@tanstack/react-router";
import { useJobTypeDrawerContext } from "@/utils/job-type-detail/job-type-drawer-context";
import { JobTypeLifecycleSection } from "./fullLifecycle";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/jobTypes/$jobTypeId/lifecycle",
)({
	component: AdminJobTypeLifecycleTab,
});

function AdminJobTypeLifecycleTab() {
	const { jobType } = useJobTypeDrawerContext();

	return (
		<div className="px-5 pb-5">
			<JobTypeLifecycleSection jobType={jobType} scope="platform" />
		</div>
	);
}
